<template>
  <div class="actions">
    <div class="actions-group">
      <ActionSave
        hint="Save settings as URL"
        @changeStorageSettings="changeStorageSettings"
      />
      <ActionLoadSettings
        hint="Recently saved URLs"
        :storage-settings="storageSettings"
        @changeStorageSettings="changeStorageSettings"
      />
    </div>
    <div class="actions-group">
      <ActionCopy hint="Copy code" />
      <ActionHint hint="Settings can be applied inline or via a script" />
    </div>
  </div>
</template>
<script>
import ActionLoadSettings from '@/widgets/common/ActionLoadSettings'
import ActionSave from '@/widgets/common/ActionSave'
import ActionHint from '@/widgets/common/ActionHint'
import ActionCopy from '@/widgets/common/ActionCopy'
export default {
  name: 'Actions',
  components: {
    ActionLoadSettings,
    ActionSave,
    ActionCopy,
    ActionHint
  },
  data() {
    return {
      storageSettings: true
    }
  },
  methods: {
    changeStorageSettings(val) {
      this.storageSettings = val
    }
  }
}
</script>
<style lang="scss">
.actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  &-group {
    display: flex;
  }
}
.hintWrapper {
  position: absolute;
  top: - 70px;
}
.hintButton {
  z-index: 9999;
  position: relative;
  right: 50%;
  transform: translateX(75%);
  display: flex;
  min-height: 55px;
  align-items: center;
  background-color: rgba(0,0,0,1);
  color: white;
  padding: 2px 10px;
  border-radius: 8px;
  &.question {
    width: 200px;
  }
  &.share {
    width: 170px;
  }
  &.save {
    width: 190px;
  }
  &::after{
    display: none;
    content: "";
    position: absolute;
    z-index: 9999;
    bottom: -10px;
    right: 50%;
    transform: translateX(50%);
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 10px 0 10px;
    border-color: rgba(0,0,0,1) transparent transparent transparent;
  }
}
@media only screen and (min-width : 480px){
  .hintButton {
    left: auto;
    transform: translateX(50%);
    &::after{
      display: block;
    }
  }
}
.infoButton{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 18px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: relative;
  img {
    max-width: 15px;
  }
}
.copywrap {
  position: relative;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.copyButton {
  justify-content: center;
  align-items: center;
  padding: 0;
  background-color: transparent;
  border: none;
  color: #327bba;
  &:hover{
    opacity: .8;
  }
}
.copymessage {
  position: absolute;
  top: -20px;
  right: -55px;
  font-size: 14px;
  color: #327bba;
  background-color: #fff;
  padding: 2px 5px;
  border-radius: 4px;
}
</style>
